import type { SVGProps } from 'react';

import * as styles from './LegacyFranchiseIcon.css';

export const LegacyFranchiseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    className={styles.peopleIcon}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15 15"
    // xml:space="preserve"
  >
    <path
      d="M14.4,11.1c0,0.1-0.1,0.1-0.1,0.2c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.1,0-0.2,0h-3.7c0.1,0.2,0.1,0.4,0.2,0.6
		c0,0.2,0.1,0.4,0.1,0.6c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.2c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.1,0-0.2,0H1.2c-0.1,0-0.1,0-0.2,0
		C1,13,1,12.9,0.9,12.9c0,0-0.1-0.1-0.1-0.2s0-0.1,0-0.2c0-0.6,0.2-1.2,0.5-1.8s0.6-1.1,1.1-1.5c0.5-0.4,1-0.8,1.5-1
		C4.5,8.1,5,8,5.7,8c0.4,0,0.7,0,1,0.1s0.7,0.2,1,0.3C7.8,8.2,8,8,8.2,7.9c0.2-0.2,0.4-0.3,0.7-0.4c0.2-0.1,0.5-0.2,0.8-0.3
		c0.3-0.1,0.5-0.1,0.8-0.1c0.5,0,1,0.1,1.4,0.3c0.5,0.2,0.9,0.5,1.2,0.8C13.5,8.6,13.8,9,14,9.4s0.3,1,0.4,1.5
		C14.4,11,14.4,11,14.4,11.1z M1.7,12.2h7.9c-0.1-0.4-0.2-0.8-0.4-1.2s-0.5-0.7-0.8-1C8,9.6,7.6,9.3,7.1,9.1s-1-0.3-1.5-0.3
		c-0.5,0-1,0.1-1.5,0.3C3.7,9.3,3.3,9.6,2.9,9.9c-0.3,0.3-0.6,0.6-0.8,1S1.8,11.8,1.7,12.2z M5.7,7.5C5,7.5,4.5,7.3,4,6.9
		s-0.7-1-0.7-1.6C3.3,4.6,3.6,4,4,3.6c0.5-0.5,1-0.7,1.7-0.7c0.6,0,1.2,0.2,1.6,0.7C7.8,4,8,4.6,8,5.2c0,0.6-0.2,1.2-0.7,1.6
		S6.3,7.5,5.7,7.5z M4.6,4.2C4.3,4.4,4.2,4.8,4.2,5.2c0,0.4,0.1,0.8,0.4,1s0.6,0.4,1.1,0.4c0.4,0,0.8-0.1,1-0.4s0.4-0.6,0.4-1
		c0-0.4-0.1-0.8-0.4-1.1s-0.6-0.4-1-0.4C5.3,3.7,4.9,3.9,4.6,4.2z M9.9,10.5h3.5c-0.1-0.3-0.2-0.6-0.3-0.9C13,9.3,12.8,9,12.5,8.8
		c-0.3-0.3-0.6-0.5-1-0.6C11.2,8,10.9,8,10.5,8C10.3,8,10.1,8,9.8,8S9.4,8.1,9.2,8.2C9.1,8.3,8.9,8.4,8.8,8.5S8.5,8.7,8.4,8.8
		C8.5,8.9,8.6,9,8.7,9.1S8.9,9.2,9,9.3c0.2,0.2,0.4,0.4,0.5,0.6C9.6,10.1,9.8,10.3,9.9,10.5C9.9,10.5,9.9,10.5,9.9,10.5z M9.3,6.2
		C9,5.9,8.8,5.5,8.8,5c0-0.5,0.2-0.9,0.5-1.2c0.3-0.3,0.7-0.5,1.2-0.5c0.5,0,0.9,0.2,1.2,0.5c0.3,0.3,0.5,0.7,0.5,1.2
		c0,0.5-0.2,0.9-0.5,1.2c-0.3,0.3-0.7,0.5-1.2,0.5C10.1,6.7,9.7,6.5,9.3,6.2z M9.9,4.4C9.8,4.5,9.7,4.8,9.7,5c0,0.2,0.1,0.4,0.3,0.6
		c0.2,0.2,0.4,0.3,0.6,0.3c0.2,0,0.4-0.1,0.6-0.3c0.2-0.2,0.3-0.4,0.3-0.6c0-0.2-0.1-0.4-0.3-0.6c-0.2-0.2-0.4-0.3-0.6-0.3
		C10.3,4.1,10.1,4.2,9.9,4.4z"
    />
  </svg>
);
